import Reflux from 'reflux';

const Actions = Reflux.createActions([
  'fetchData',
  'getMonths',
  'getLineChartData'
]);

export default Actions;



/** WEBPACK FOOTER **
 ** ./src/components/data_visualisation/actions.js
 **/